// Exports
export default {
	"Link": "Link_D07L9"
};
